module.exports = __webpack_public_path__ + "static/media/hashple_logo_full.24aa4646.png";